import React, { Suspense } from 'react';
import { Loading } from './Loading';

interface SuspendedProps {
  children: React.ReactNode;
}
export const Suspended = (props: SuspendedProps): JSX.Element => {
  return <Suspense fallback={<Loading />}>{props.children}</Suspense>;
};
